// extracted by mini-css-extract-plugin
export default {"scrumMaster":"ScrumMaster_scrumMaster__vp7af"};